var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatreon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 542 542",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "path3204",
    transform: "matrix(0.831929,0,0,0.831929,12.6219,-162.074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.305,210.444C199.789,210.444 78.586,331.647 78.586,481.162L78.586,751.631L337.961,751.631C341.722,751.786 345.506,751.881 349.305,751.881C498.82,751.881 620.024,630.678 620.024,481.162C620.024,331.647 498.82,210.444 349.305,210.444Z",
    style: {
      fill: "rgb(255,89,0)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3192",
    transform: "matrix(0.831929,0,0,0.831929,12.6219,-162.074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.305,273.287C234.505,273.287 141.43,366.362 141.43,481.162L141.43,751.631L224.617,751.631L224.617,481.381C224.617,412.74 280.258,357.069 348.899,357.069C417.54,357.069 473.18,412.74 473.18,481.381C473.18,550.022 417.54,605.662 348.899,605.662C323.803,605.662 300.436,598.204 280.899,585.412L280.899,674.756C293.989,682.811 323.875,688.5 358.93,688.787C469.258,683.754 557.18,592.734 557.18,481.162C557.18,366.362 464.105,273.287 349.305,273.287ZM340.586,688.819C343.474,688.938 346.388,689.037 349.305,689.037C352.375,689.037 355.423,688.95 358.461,688.819L340.586,688.819Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatreon);
export default __webpack_public_path__ + "static/media/patreon.025f9318c0f720ab7c339127fd17a2c8.svg";
export { ForwardRef as ReactComponent };